import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, ArrowUpRight, X } from "lucide-react";
import { api } from "../../lib/api";
import "./Showreel.css";


export const Showreel = () => {

    const [featured, setFeatured] = useState([]);
    const [active, setActive] = useState(null);

    useEffect(() => {
        api.get("/videos", { params: { featured: true } })
            .then((r) => setFeatured(r.data.slice(0, 3)))
            .catch((e) => console.error("showreel fetch", e));
    }, []);

    useEffect(() => {
        if (!active) return;
        const onKey = (e) => e.key === "Escape" && setActive(null);
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [active]);

    if (featured.length === 0) return null;

    return (
        <section
            data-testid="showreel-section"
            className="showreel-section py-5 py-md-10 border-top"
        >
            <div className="container-db">
                <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-4 mb-5">
                    <div>
                        <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                            ⟶ Broadcast Reel
                        </div>
                        <h2 className="font-heading section-heading mb-0">
                            Watch the Showreel
                        </h2>
                    </div>
                    <Link
                        to="/videos"
                        data-testid="showreel-view-all"
                        className="immersive-link font-mono-tech text-decoration-none align-self-start"
                    >
                        Full Video Gallery <ArrowUpRight size={16} />
                    </Link>
                </div>

                <div className="row g-3">
                    {featured.map((v) => (
                        <div key={v.id} className="col-12 col-md-6">
                            <button
                                type="button"
                                onClick={() => setActive(v)}
                                data-testid={`showreel-video-${v.id}`}
                                className="position-relative w-100 border overflow-hidden showreel-hero-btn group-hover-parent text-start p-0"
                            >
                                <img
                                    src={`https://img.youtube.com/vi/${v.id}/hqdefault.jpg`}
                                    alt={v.title}
                                    className="absolute-img bg-cover bg-center"
                                />
                                <div className="showreel-overlay" />
                                <div className="position-absolute inset-0 d-flex align-items-center justify-content-center">
                                    <span className="play-btn-large d-flex align-items-center justify-content-center">
                                        <Play size={24} fill="currentColor" strokeWidth={0} className="ms-1" />
                                    </span>
                                </div>
                                <div className="position-absolute start-3 end-3 bottom-3 start-md-4 end-md-4 bottom-md-4">
                                    <p className="font-heading showreel-title m-0" style={{ fontSize: "18px" }}>
                                        {v.title}
                                    </p>
                                </div>
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {active && (
                <div
                    data-testid="showreel-lightbox"
                    className="position-fixed top-0 bottom-0 start-0 end-0 lightbox-overlay d-flex align-items-center justify-content-center p-4 p-md-5"
                    onClick={() => setActive(null)}
                >
                    <button
                        onClick={() => setActive(null)}
                        data-testid="showreel-lightbox-close"
                        aria-label="Close video"
                        className="position-absolute top-4 end-4 top-md-5 end-md-5 btn-lightbox-close"
                    >
                        <X size={28} />
                    </button>
                    <div className="w-100 max-w-6xl" onClick={(e) => e.stopPropagation()}>
                        <div className="aspect-video w-100 bg-black border border-secondary">
                            <iframe
                                title={active.title}
                                src={`https://www.youtube.com/embed/${active.id}?autoplay=1&rel=0`}
                                className="w-100 h-100"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        <h6 className="mt-4 font-heading lightbox-title">
                            {active.title}
                        </h6>
                    </div>
                </div>
            )}
        </section>
    );
};


export default Showreel;
